import type { Testimonial } from "@/types/content";

export const testimonials: Testimonial[] = [
  {
    name: "小满",
    role: "每天通勤刷一刷",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20avatar%20illustration%20of%20a%20cheerful%20young%20woman%20with%20short%20hair%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20plain%20background%2C%20no%20text&width=200&height=200&seq=avatar-01-2026&orientation=squarish",
    quote:
      "分类做得很清楚，早上通勤十分钟就能把昨晚到今早的瓜过一遍，不用再翻来翻去。",
  },
  {
    name: "阿哲",
    role: "影视爱好者",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20avatar%20illustration%20of%20a%20calm%20young%20man%20with%20glasses%2C%20warm%20golden%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20plain%20background%2C%20no%20text&width=200&height=200&seq=avatar-02-2026&orientation=squarish",
    quote:
      "影评不吹不黑，点映口碑那几篇写得挺实在，进场之前看一眼能少踩不少坑。",
  },
  {
    name: "团团",
    role: "综艺十级观众",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20avatar%20illustration%20of%20a%20lively%20girl%20with%20ponytail%2C%20warm%20teal%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20plain%20background%2C%20no%20text&width=200&height=200&seq=avatar-03-2026&orientation=squarish",
    quote:
      "热瓜榜很上头，每次想只看一条，结果顺着榜单又刷了半小时，痛并快乐着。",
  },
  {
    name: "老K",
    role: "音乐现场常客",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20avatar%20illustration%20of%20a%20relaxed%20man%20with%20beanie%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20plain%20background%2C%20no%20text&width=200&height=200&seq=avatar-04-2026&orientation=squarish",
    quote:
      "Livehouse 巡演那篇说出了我的心声。在这里能找到同好，评论区比正文还热闹。",
  },
  {
    name: "柚子",
    role: "时尚打工人",
    avatar:
      "https://readdy.ai/api/search-image?query=flat%20vector%20avatar%20illustration%20of%20a%20stylish%20young%20woman%20with%20long%20hair%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20minimal%20geometric%20style%2C%20plain%20background%2C%20no%20text&width=200&height=200&seq=avatar-05-2026&orientation=squarish",
    quote:
      "叠穿那篇真的能照着穿，没有堆术语，图片风格也很统一，看着舒服。",
  },
];